import {
  AnyAction,
  combineReducers,
  configureStore,
  Middleware,
  ThunkDispatch,
} from '@reduxjs/toolkit'
import homeReducer from './slice/homeSlice'
import templateConfigReducer from './slice/templateConfigurationSlice'
import templateHistoryReducer from './slice/templateHistorySlice'
import commonSliceReducer from './slice/commonSlice'
import domainSliceReducer from './slice/domainSlice'
import authSliceReducer from './slice/authSlice'
import maintenanceSliceReducer from './slice/maintenanceSlice'

// const development: boolean = process.env.NODE_ENV === 'development'

const development: boolean = true

const middleware: Middleware[] = []

const reducer = combineReducers({
  fileHistory: homeReducer,
  templateConfig: templateConfigReducer,
  templateHistory: templateHistoryReducer,
  common: commonSliceReducer,
  domain: domainSliceReducer,
  auth: authSliceReducer,
  maintenance: maintenanceSliceReducer,
})

const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) => [
    ...getDefaultMiddleware(),
    ...middleware,
  ],
  devTools: development,
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
export type TypedDispatch<T> = ThunkDispatch<T, any, AnyAction>

export default store
